import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';

/**
 * Empty state component displayed when no data is available
 */
const EmptyState = ({ title, message, onClearFilters }) => (
  <Box
    role="status"
    aria-live="polite"
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      p: 4,
      minHeight: 300,
      textAlign: 'center',
    }}
  >
    <InboxOutlinedIcon
      aria-hidden="true"
      sx={{
        fontSize: 64,
        color: 'grey.400',
        mb: 2,
      }}
    />
    <Typography variant="h6" sx={{ mb: 1, color: 'text.secondary' }}>
      {title || 'Nenhum resultado encontrado'}
    </Typography>
    {message && (
      <Typography variant="body2" sx={{ color: 'text.secondary', maxWidth: 400 }}>
        {message}
      </Typography>
    )}
    {onClearFilters && (
      <Typography
        variant="body2"
        role="button"
        tabIndex={0}
        onClick={onClearFilters}
        onKeyPress={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClearFilters();
          }
        }}
        sx={{
          color: 'text.secondary',
          maxWidth: 400,
          mt: 2,
          cursor: 'pointer',
          textDecoration: 'underline',
        }}
      >
        Limpar filtros
      </Typography>
    )}
  </Box>
);

EmptyState.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  onClearFilters: PropTypes.func,
};

EmptyState.defaultProps = {
  title: 'Nenhum resultado encontrado',
  message: 'Tente ajustar os filtros para encontrar o que procura.',
  onClearFilters: null,
};

export default EmptyState;
